import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the eloquaVerify state domain
 */

const selectEloquaVerifyDomain = state => state.eloquaVerify || initialState;

/**
 * Other specific selectors
 */

const makeSelectIsVerify = () =>
  createSelector(selectEloquaVerifyDomain, subState => subState.isVerify);

const makeSelectError = () => createSelector(selectEloquaVerifyDomain, subState => subState.error);

export { makeSelectIsVerify, makeSelectError };
